import { fileExtensionsToIcon } from "#shared/helpers/fileExtensionsToIcon";
import { IconName } from "#shared/icons/Icon";
import { getFileExtension } from "shared";

/**
 * Retrieves the icon name based on the file extension.
 *
 * @param fileName - The name of the file.
 * @param defaultIcon - The default icon name to use if the file extension is not found in the mapping.
 * @returns The icon name corresponding to the file extension, or the default icon name if not found.
 */
export const getFileIcon = (fileName: string, defaultIcon: IconName = "fileBlank"): IconName => {
  const extension = getFileExtension(fileName);

  return fileExtensionsToIcon[extension] ?? defaultIcon;
};
